import { http } from "./api";

export const resources = {
    createQuestion: async (question) => {
        try {
            const response = await http.post("/v1/resources/faqs", question);

            if (!response?.success) {
                console.warn(
                    "La respuesta del servidor no contiene un recurso válido:",
                    response
                );
                return {
                    success: false,
                    requestCode: response?.requestCode || 500,
                    message:
                        "No se pudo crear la pregunta - respuesta inválida del servidor",
                    id: null,
                };
            }

            return {
                success: true,
                message: "Pregunta creada exitosamente",
                id: response.data.resource.id,
            };
        } catch (error) {
            console.error("Error al crear la pregunta:", error);
            return {
                success: false,
                requestCode: error.response?.status || 500,
                message: "No se pudo crear la pregunta",
            };
        }
    },

    getFaqs: async () => {
        try {
            const response = await http.get(
                "/v1/resources/faqs/select-options"
            );

            if (!response?.success) {
                console.warn(
                    "La respuesta del servidor no contiene un recurso válido:",
                    response
                );
                return {
                    success: false,
                    message: "No se pudieron obtener las preguntas frecuentes",
                    data: [],
                };
            }

            return {
                success: true,
                data: response.data || [],
            };
        } catch (error) {
            console.error("Error al obtener las preguntas frecuentes:", error);
            return {
                success: false,
                message: "Error al obtener las preguntas frecuentes",
                data: [],
            };
        }
    },

    //////////////////////////////////////
    // Seccion para agregar videos
    //////////////////////////////////////

    createVideo: async (video) => {
        try {
            const response = await http.post("/v1/resources/videos", video);
            if (!response?.success) {
                console.warn(
                    "LA respuesta del servidor no contiene un recurso válido:",
                    response
                );

                return {
                    success: false,
                    requestCode: response?.requestCode || 500,
                    message:
                        "No se pudo crear el video - respuesta inválida del servidor",
                    id: null,
                };
            }
            return {
                success: true,
                message: "Video creado exitosamente",
                id: response.data.resource.id,
            };
        } catch (error) {
            console.error("Error al cargar el video:", error);
            return {
                success: false,
                message: "Error al cargar el video",
                data: [],
            };
        }
    },

    getVideos: async () => {
        try {
            const response = await http.get(
                "/v1/resources/videos/select-options"
            );

            if (!response?.success) {
                console.warn(
                    "La respuesta del servidor no contiene un recurso válido:",
                    response
                );
                return {
                    success: false,
                    requestCode: response?.requestCode || 500,
                    message:
                        "No se pudo obtener el video - respuesta inválida del servidor",
                    data: [],
                };
            }

            return {
                success: true,
                requestCode: response.requestCode,
                data: response.data || [],
            };
        } catch (error) {
            console.error("Error al obtener los videos:", error);
            return {
                success: false,
                message: "Error al obtener los videos",
                data: [],
            };
        }
    },
};
